import { render, staticRenderFns } from "./element-details.vue?vue&type=template&id=778bac70&scoped=true&"
import script from "./element-details.vue?vue&type=script&lang=js&"
export * from "./element-details.vue?vue&type=script&lang=js&"
import style0 from "./element-details.vue?vue&type=style&index=0&id=778bac70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778bac70",
  null
  
)

export default component.exports